import { z } from "zod";
import { apiListSchema } from "./list";
import {
  createPersonDtoSchema,
  personDtoSchema,
  personFromDto,
  PersonSchema,
  personToDto,
} from "./person";

//? DTO
export const CreateGuideDtoSchema = z.object({
  Person: createPersonDtoSchema,
});
export type CreateGuideDto = z.infer<typeof CreateGuideDtoSchema>;

export const GuideDtoSchema = CreateGuideDtoSchema.extend({
  Id: z.number(),
  PersonId: z.number(),
  Person: personDtoSchema,
});
export type GuideDto = z.infer<typeof GuideDtoSchema>;

export const guideDtoListSchema = apiListSchema(GuideDtoSchema);

//? Model

export const CreateGuideSchema = PersonSchema.extend({
  personId: z.string(),
});
export type CreateGuide = z.infer<typeof CreateGuideSchema>;

export const GuideSchema = CreateGuideSchema.extend({
  id: z.string().min(1),
});

export type Guide = z.infer<typeof GuideSchema>;

//? Mappers

export function mapCreateGuideToDto(service: CreateGuide): CreateGuideDto {
  return {
    Person: personToDto(service),
  };
}

export function mapGuideFromDto(dto: GuideDto): Guide {
  return {
    id: dto.Id.toString(),
    personId: dto.PersonId.toString(),
    ...personFromDto(dto.Person),
  };
}

export function mapGuideToDto(dto: Guide): GuideDto {
  return {
    Id: Number.parseInt(dto.id),
    PersonId: Number.parseInt(dto.personId ?? ""),
    Person: {
      Id: Number.parseInt(dto.personId ?? ""),
      ...personToDto(dto),
    },
  };
}
